import CustomerType from '../../types/customer';
import getFutureDate from '../get-future-date';
import PriceService from '../../models/price';

const getCustomerHasChanged = (customer: Partial<CustomerType>, useFutureEffectiveDate?: boolean) => {
  const emptyProductId = '';
  return PriceService.getKey(emptyProductId, customer, { date: getFutureDate(useFutureEffectiveDate) });
};

export default getCustomerHasChanged;
